export default __webpack_public_path__ + "static/media/imone-title-en.2437a7e0.webp";